import { HOME_CUSTOMER_URL, API_REQUESTS } from '../../helper/constant';
import * as Types from '../../constants/actionTypes';
import axios from 'axios'
import { AUTH_SERVICE_URL } from '../../helper/constant'
import AuthAxios from '../../models/HomeOfficeAxios'
import AuthHomeCustomer from '../../models/AuthHomeCustomer'
import { NO_ACCESS_PORTAL_CODE } from '../../constants/permissions'
import AxiosHomeCustomer from '../../helper/AxiosHomeCustomer'


export const GET_REQUEST_DETAILS = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.post(`${HOME_CUSTOMER_URL}/home-request-raise/listRequestdetails`, payload);
        dispatch({ type: Types.REQUEST_DETAILS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.USER_LOCATION_DETAILS_FAILED, errorMessage: message })
    }
}
export const DELETE_USER = (payload) => async (dispatch) => {
    try {
        let URL = `${AUTH_SERVICE_URL}/homeoffice/deleteHomeUser`
        const response = await AuthAxios.axios.post(URL, payload);
        dispatch({ type: Types.REQUEST_DETAILS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.USER_LOCATION_DETAILS_FAILED, errorMessage: message })
    }
}

export const GET_REQUEST_DETAILS_COUNT = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.post(`${HOME_CUSTOMER_URL}/home-request-raise/listRequestdetailsCount`, payload);
        dispatch({ type: Types.REQUEST_DETAILS_COUNT, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.USER_LOCATION_DETAILS_FAILED, errorMessage: message })
    }
}
export const GET_HOME_CUSTOMER_REQUEST_TYPES = ({ portalId, clientId }) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.get(`${HOME_CUSTOMER_URL}/home-request-raise/fetchRequestType?portalId=${portalId}&clientId=${clientId}`);
        dispatch({ type: Types.HOME_CUSTOMER_REQUEST_TYPES, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.USER_LOCATION_DETAILS_FAILED, errorMessage: message })
    }
}
export const SENT_HOME_CUSTOMER_EMAIL = (payload) => async (dispatch) => {
    const URL = `${AUTH_SERVICE_URL}/homeoffice/loginOtp`;
    try {
        const response = await axios.post(URL, payload);
        dispatch({ type: Types.COGNITO_USER_DETAILS, data: response.data && response.data.data })
    } catch (error) {
        dispatch({ type: Types.USER_FAILED, errorMessage: error.message })
    }
}
export const SENT_HOME_CUSTOMER_OTP = (payload) => async (dispatch) => {
    const URL = `${AUTH_SERVICE_URL}/homeoffice/loginOtpVerify`;
    try {
        AuthHomeCustomer._clearUserCache();
        const response = await axios.post(URL, payload);
        dispatch({ type: Types.USER_LOGIN_DETAILS, data: (response.data && response.data.data) })
        if ((response.data && response.data.data)) {
            AuthHomeCustomer.setUserData(response.data && response.data.data)
        }
    } catch (error) {
        dispatch({ type: Types.USER_FAILED, errorMessage: error.message })
    }
}


export const GET_REQUEST_BY_REQUEST_ID = (payload) => async (dispatch) => {

    try {
        const response = await AuthAxios.axios.post(`${HOME_CUSTOMER_URL}/home-request-raise/fetchRequestdetails`, payload);
        dispatch({ type: Types.REQUEST_DETAILS_BY_REQUESTID, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.USER_LOCATION_DETAILS_FAILED, errorMessage: message })
    }
}

export const PRINT_CARRIER_LABELS = (payload) => async (dispatch) => {
    try {
        const response = await AuthAxios.axios.post(`${HOME_CUSTOMER_URL}/home-request-raise/printRequestLabels`, payload);
        dispatch({ type: Types.REQUEST_CARRIER_LABELS, data: response.data && response.data, requestId: payload.requestId })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.REQUEST_CARRIER_LABELS_ERROR, errorMessage: message })
    }
}

export const SET_CARRIER_LABEL_ERROR = (message) => async (dispatch) => {
    dispatch({ type: Types.REQUEST_CARRIER_LABELS_ERROR, errorMessage: message })
}

export const ADD_REQUEST = (payload) => async (dispatch) => {
    try {

        const url = `${HOME_CUSTOMER_URL}/home-request-raise/saveRequestdetails`
        // const response = await axios.post(,payload)
        const response = await AuthAxios.axios.post(url, payload)
        await dispatch({ type: Types.REQUEST_SUCCESS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.USER_FAILED, errorMessage: message })
    }
}
export const UPDATE_REQUEST = (payload) => async (dispatch) => {
    try {

        const url = `${HOME_CUSTOMER_URL}/home-request-raise/updateRequestdetails`
        const response = await AuthAxios.axios.post(url, payload)
        dispatch({ type: Types.REQUEST_SUCCESS, data: response.data })
        dispatch({ type: Types.REQUEST_SUCCESS_MESSAGE, data: response.data })
    } catch (error) {
        console.log(error, 'error')
        let response = error.response
        let message = response && response.data
        if (error.message) {
            message = error.message
        }
        dispatch({ type: Types.REQUEST_FAILED, errorMessage: message })
    }
}
export const DELETE_REQUEST = (payload) => async (dispatch) => {
    try {

        const url = `${HOME_CUSTOMER_URL}/home-request-raise/deleteRequest`
        // const response = await axios.post(,payload)
        const response = await AuthAxios.axios.post(url, payload)
        dispatch({ type: Types.REQUEST_SUCCESS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.USER_FAILED, errorMessage: message })
    }
}

export const INITIATE_REQUEST_STATUS = (payload) => async (dispatch) => {
    try {

        const url = `${HOME_CUSTOMER_URL}/home-request-raise/InitiateRequestStatus`
        // const response = await axios.post(,payload)
        const response = await AuthAxios.axios.post(url, payload)
        dispatch({ type: Types.REQUEST_SUCCESS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.USER_FAILED, errorMessage: message })
    }
}

export const ADD_USER = (payload) => async (dispatch) => {
    try {

        const url = `${AUTH_SERVICE_URL}/homeoffice/signup`
        // const response = await axios.post(,payload)
        const response = await AuthAxios.axios.post(url, payload)
        dispatch({ type: Types.USER_SUCCESS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        if (!error.status) {
            message = error.message
        }
        dispatch({ type: Types.USER_FAILED, errorMessage: message })
    }
}
export const GENERATE_USER_TOKEN = (payload) => async (dispatch) => {
    const url = `${HOME_CUSTOMER_URL}/home-request-raise/generateAPIToken`
    try {
        const response = await AuthAxios.axios.post(url, payload)
        return response.data
    } catch (exception) {
        dispatch({ type: Types.USER_ACCESS_TOKEN_FAILED, programFeedbackQuestionError: exception.message })
    }
}
export const getAPIToken = (payload) => async (dispatch) => {
    const url = `${HOME_CUSTOMER_URL}/home-request-raise/getAPIToken`
    try {
        const response = await AuthAxios.axios.post(url, payload)
        dispatch({ type: Types.USER_ACCESS_TOKEN, payload: response.data })
    } catch (exception) {
        dispatch({ type: Types.USER_ACCESS_TOKEN_FAILED, programFeedbackQuestionError: exception.message })
    }
}

export const UPDATE_USER = (payload) => async (dispatch) => {
    try {

        const url = `${AUTH_SERVICE_URL}/homeoffice/updateUserInfo`
        // const response = await axios.post(,payload)
        const response = await AuthAxios.axios.post(url, payload)
        dispatch({ type: Types.USER_SUCCESS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        if (!error.status) {
            message = error.message
        }
        dispatch({ type: Types.USER_FAILED, errorMessage: message })
    }
}

export const DOWNLOAD_USER_TEMPLATE = (portalId) => async (dispatch) => {
    try {
        const ADDRESS_URL = `${AUTH_SERVICE_URL}/homeoffice/download-user-template`;
        let date = new Date()
        const fullDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
        const fileName = `HomeUsers_${fullDate}.xlsx`
        const userResponse = await AuthAxios.axios.post(ADDRESS_URL, { fileName, portalId }, { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([userResponse.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();


    } catch (error) {

        // dispatch({ type: Types.PORTAL_COLLECTION_ADDRESS_ERROR, addressError: error.message })
    }
}
export const DOWNLOAD_REQUEST_TEMPLATE = (payload) => async (dispatch) => {
    try {
        const ADDRESS_URL = `${HOME_CUSTOMER_URL}/home-request-raise/createBulkCollectionTemplate`;
        let date = new Date()
        const fullDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
        const fileName = `HomeCollectionRequests_${fullDate}.xlsx`
        const userResponse = await AuthAxios.axios.post(ADDRESS_URL, { fileName, ...payload }, { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([userResponse.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();


    } catch (error) {

        // dispatch({ type: Types.PORTAL_COLLECTION_ADDRESS_ERROR, addressError: error.message })
    }
}

export const DOWNLOAD_PACKAGE_DOCUMENT = (payload) => async (dispatch) => {
    try {
        const { requestTypeId, portalId, docName } = payload
        if (!requestTypeId || !portalId || !docName) {
            dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please Provide Request Document Information`
            })
        }

        const REQ_URL = `${AUTH_SERVICE_URL}/homeoffice/requestPackageInstctionDocDownload`
        const response = await AuthAxios.axios.post(REQ_URL, payload, { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'PackageInstructions_UPS.pdf');
        document.body.appendChild(link);
        link.click();
        // dispatch({
        //     type: Types.REQUEST_DOCS_DOWNLOAD,
        //     reqDocDownload: response.data
        // })
    } catch (error) {
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}

export const DOWNLOAD_CARRIER_DOCUMENT = (payload) => async (dispatch) => {
    try {
        const { requestId, filename } = payload
        if (!requestId || !filename) {
            dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please Provide Document Information`
            })
        }
        const URL = `${AUTH_SERVICE_URL}/portal/downloadCarrierDocument`;
        const response = await AuthAxios.axios.post(URL, payload, { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        dispatch({
            type: Types.REQUEST_DOCS_ERROR,
            error: error && error.message
        })
    }
}

export const LIST_PORTAL_STATUSES = (payload) => async (dispatch) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            dispatch({
                type: Types.REQUEST_DOCS_ERROR,
                error: `Please Provide Request Document Information`
            })
        }

        const URL = `${HOME_CUSTOMER_URL}/home-request-raise/listPortalStageStatus`;
        const response = await AuthAxios.axios.post(URL, payload);
        dispatch({ type: Types.PORTAL_STATUSES, data: response.data })
    } catch (error) {
        dispatch({
            type: Types.PORTAL_STATUSES_ERROR,
            error: error && error.message
        })
    }
}
export const UPLOAD_BULK_USERS = (fileData, payload) => async (dispatch) => {
    try {
        const ADDRESS_URL = `${AUTH_SERVICE_URL}/homeoffice/upload-multiple-users`;
        const { portalId, clientId } = payload;
        if (!portalId || !clientId) {
            dispatch({ type: Types.BULK_USERS_ERROR, addressError: `Portal Information is not found` })
        }
        const response = await AuthAxios.axios.post(ADDRESS_URL, fileData, { params: payload })
        if (response && response.data) {
            if (response && response.data.error) {
                dispatch({ type: Types.BULK_USERS_ERROR, addressError: response.data.error })
            } else {
                dispatch({ type: Types.UPLOAD_BULK_USERS, collectionData: response.data.data })
            }

        }
    } catch (error) {
        dispatch({ type: Types.BULK_USERS_ERROR, addressError: error.response.data.error && error.response.data.error.message })
        // console.log('UPLOAD_BULK_USERS',error)
        // const addressError = error.message.indexOf('already exist') > -1 ? error.error : error.message;
        // dispatch({ type: Types.BULK_USERS_ERROR, addressError})
    }
}

export const UPLOAD_BULK_REQUESTS = (fileData, payload) => async (dispatch) => {
    try {
        const ADDRESS_URL = `${AUTH_SERVICE_URL}/homeoffice/bulkCollectionRequestUpload`;
        const { portalId, clientId } = payload;
        if (!portalId || !clientId) {
            dispatch({ type: Types.BULK_USERS_ERROR, addressError: `Portal Information is not found` })
        }
        const response = await AuthAxios.axios.post(ADDRESS_URL, fileData, { params: payload })
        if (response && response.data) {
            if (response && response.data.error) {
                dispatch({ type: Types.BULK_USERS_ERROR, addressError: response.data.error })
            } else {
                dispatch({ type: Types.UPLOAD_BULK_REQUESTS, bulkUploadStatus: response.data && response.data.data.finalData })
            }
        }
    } catch (error) {
        // console.log('UPLOAD_BULK_USERS',error)
        // const addressError = error.message.indexOf('already exist') > -1 ? error.error : error.message;
        // dispatch({ type: Types.BULK_USERS_ERROR, addressError})
    }
}
export const SET_BULK_REQUEST_DATA = (payload) => async (dispatch) => {
    dispatch({ type: Types.UPLOAD_BULK_REQUESTS, bulkUploadStatus: payload })
}

export const SET_USER_ERROR = (payload) => async (dispatch) => {
    dispatch({ type: Types.REQUEST_FAILED, errorMessage: payload })
}
export const SET_NORMAL_USER_ERROR = (payload) => async (dispatch) => {
    dispatch({ type: Types.USER_FAILED, errorMessage: payload })
}


export const ADD_COLLECTION_ADDRESS = (payload) => async (dispatch) => {
    const URL = `${AUTH_SERVICE_URL}/client/homecreateCollection`;
    try {
        const response = await AuthAxios.axios.post(URL, payload,);
        dispatch({ type: Types.COLLECTION_ADDRESS_SUCCESS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.USER_FAILED, errorMessage: message })
    }
}
export const SET_USER_FAILED_ERROR = (payload) => async (dispatch) => {
    dispatch({ type: Types.USER_FAILED, errorMessage: payload })
}
export const GET_COLLECTION_ADDRESS_BY_REQUEST_ID = (payload) => async (dispatch) => {
    const URL = `${AUTH_SERVICE_URL}/client/homegetCollectionBySite`;
    try {
        const response = await AuthAxios.axios.post(URL, payload);
        dispatch({ type: Types.COLLECTION_ADDRESS_SUCCESS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.USER_LOCATION_DETAILS_FAILED, errorMessage: message })
    }
}
export const GET_ALL_PORTAL_COUNTRIES = (payload) => async (dispatch) => {
    const URL = `${HOME_CUSTOMER_URL}/home-request-raise/fetchHomeCustomerCountries`;
    try {
        const response = await AuthAxios.axios.post(URL, payload);
        dispatch({ type: Types.PORTAL_COUNTRIES, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.PORTAL_COUNTRIES_FAILED, errorMessage: message })
    }
}
export const GET_ALL_PORTAL_ASSETS = (payload) => async (dispatch) => {
    const URL = `${HOME_CUSTOMER_URL}/home-request-raise/getHomeCustomersAssets`;
    try {
        const response = await AuthAxios.axios.post(URL, payload);
        dispatch({ type: Types.PORTAL_ASSETS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.PORTAL_ASSETS_FAILED, errorMessage: message })
    }
}
export const FETCH_BRANDS = (payload) => async (dispatch) => {
    const URL = `${HOME_CUSTOMER_URL}/home-request-raise/homefetchBrands`;
    try {
        const response = await AuthAxios.axios.post(URL, payload);
        dispatch({ type: Types.HOME_BRANDS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.PORTAL_ASSETS_FAILED, errorMessage: message })
    }
}

export const FETCH_PORTAL_BRANDS = (payload) => async (dispatch) => {
    const URL = `${HOME_CUSTOMER_URL}/home-request-raise/homefetchPortalBrands`;
    try {
        const response = await AuthAxios.axios.post(URL, payload);
        dispatch({ type: Types.HOME_BRANDS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.PORTAL_ASSETS_FAILED, errorMessage: message })
    }
}

export const GET_PORTAL_RECYCLING_PARTNERS = (payload) => async (dispatch) => {
    const URL = `${HOME_CUSTOMER_URL}/home-request-raise/homefetchPortalRecyclingPartner`;
    try {
        const response = await AuthAxios.axios.post(URL, payload);
        return response && response.data && response.data.data
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.PORTAL_ASSETS_FAILED, errorMessage: message })
    }
}

export const GET_ALL_COLLECTION_ADDRESS = (payload) => async (dispatch) => {
    const URL = `${AUTH_SERVICE_URL}/client/listHomeCustomerCollectionAddresses`;
    try {
        const response = await AuthAxios.axios.post(URL, payload);
        dispatch({ type: Types.COLLECTION_ADDRESS_DETAILS, data: response.data })
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.COLLECTION_ADDRESS_DETAILS_FAILED, errorMessage: message })
    }
}

export const GET_USER_DETAILS = (payload) => async (dispatch) => {
    try {
        const URL = `${AUTH_SERVICE_URL}/homeoffice/listHomeUsers`;
        const response = await AuthAxios.axios.post(URL, payload);
        dispatch({ type: Types.USER_DETAILS, data: response.data })
        // const response = await axios.post(`${LOCAL_URL}/home-request-raise/listRequestdetails`,payload);
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.USER_LOCATION_DETAILS_FAILED, errorMessage: message })
    }
}
export const GET_USER_DETAILS_BY_USER_ID = (payload) => async (dispatch) => {
    try {
        const URL = `${AUTH_SERVICE_URL}/homeoffice/fetchOneHomeUser`;
        const response = await AuthAxios.axios.post(URL, payload);
        dispatch({ type: Types.USER_DETAILS_BY_USER_ID, data: response.data })
        // const response = await axios.post(`${LOCAL_URL}/home-request-raise/listRequestdetails`,payload);
    } catch (error) {
        let response = error.response
        let message = response && response.data
        dispatch({ type: Types.USER_DETAILS_BY_USER_ID_FAILED, errorMessage: message })
    }
}

export const UN_AUTHORIZED_TROZEN_ACCESS_FOR_HOME_OFFICE = (isNotAllowedAlready) => async (dispatch) => {
    if (!isNotAllowedAlready) {
        dispatch({ type: Types.ON_LOGOUT });

        dispatch({ type: Types.INITIATE_UNAUTHORIZED_ACCESS_FOR_HOME_USER })
        if (AuthHomeCustomer.username && AuthHomeCustomer.portalId && AuthHomeCustomer.clientId) {
            const logoutPayload = {
                username: AuthHomeCustomer.username,
                portalId: AuthHomeCustomer.portalId,
                clientId: AuthHomeCustomer.clientId
            }
            await AuthAxios.axios.post(`${AUTH_SERVICE_URL}/portal/user-logout`, logoutPayload)

        }
        AuthHomeCustomer.logout();
    }
}
export const GET_PROGRAM_DATA_FOR_HOME_USER = (payload) => async (dispatch) => {
    try {
        const programData = await AuthAxios.axios.get(`${HOME_CUSTOMER_URL}${API_REQUESTS.PROGRAMS}/getPortal/${payload.portalId}`)
        //console.log(`programData is:`, programData.data);
        await dispatch({ type: Types.PROGRAM_DATA, programData: programData.data && programData.data.data })
    } catch (exception) {
        if (exception.portalCode && exception.portalCode === NO_ACCESS_PORTAL_CODE) {
            // console.log(`fetch program by id trojan`, exception)
            AxiosHomeCustomer.unauthorizedTrozenAccess()
        }
        dispatch({ type: Types.PROGRAM_ERROR, programError: exception.message })
    }
}
export const SET_IS_USER_AUTHENTICATED_FOR_HOME_CUSTOMER = (isHomeUserAuthenticated) => (dispatch) => {
    dispatch({ type: Types.IS_HOME_USER_AUTHENTICATED, isHomeUserAuthenticated })
}

export const GET_CULTURE_BY_ID = (payload) => async (dispatch) => {
    try {
        const URL = `${HOME_CUSTOMER_URL}/cultures/getCultureById`;
        const response = await AuthAxios.axios.post(URL, payload);
        return response.data && response.data.data
    } catch (err) {
        dispatch({ type: Types.CLIENT_TERMS_ERROR, payload: err });
    }
}

export const GET_ALL_PROGRAM_LANGUAGES = (payload) => async (dispatch) => {
    try {
        const URL = `${HOME_CUSTOMER_URL}/programcultures/getProgramCultureList`
        const response = await AuthAxios.axios.get(URL, { params: payload })
        await dispatch({
            type: Types.CULTURES_DETAIL_SUCCESS,
            payload: response.data && response.data.data,
        })
    } catch (error) {
        dispatch({ type: Types.CULTURES_DETAIL_ERROR, payload: error })
    }
}

